import { useState, useEffect, useCallback } from 'react';
import { cookieUtils } from '../utils';

// We now manage three categories.
export const COOKIES_PREFS_KEY = 'bodhiwell_cookie_preferences';

export interface CookiePreferences {
  essential: boolean;
  preferences: boolean;
  analytics: boolean;
}

export const useCookiesConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const [preferences, setPreferences] = useState<CookiePreferences>({
    essential: true,
    preferences: false,
    analytics: false,
  });

  useEffect(() => {
    const saved = cookieUtils.get(COOKIES_PREFS_KEY);
    if (!saved) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    } else {
      try {
        const parsed = JSON.parse(saved);
        setPreferences(parsed);
      } catch (e) {
        setIsVisible(true);
      }
    }
  }, []);

  const savePreferences = useCallback((prefs: CookiePreferences) => {
    cookieUtils.set(COOKIES_PREFS_KEY, JSON.stringify(prefs), 365);
    setPreferences(prefs);
    setIsVisible(false);
    setIsOverlayVisible(false);
  }, []);

  const handleAcceptAll = useCallback(() => {
    savePreferences({ essential: true, preferences: true, analytics: true });
  }, [savePreferences]);

  const handleEssentialOnly = useCallback(() => {
    savePreferences({ essential: true, preferences: false, analytics: false });
  }, [savePreferences]);

  return {
    isVisible,
    isOverlayVisible,
    setIsOverlayVisible,
    preferences,
    setPreferences,
    handleAcceptAll,
    handleEssentialOnly,
    savePreferences
  };
};